/*
 *
 * Account Actions
 *
 * @version 1.0.0
 * @author Giuseppe
 * @since 09-Jan-2023
 */

import { createRequestTypes, createAction, MakeRequest } from 'Store/actions/index';

export const actionTypes = {
	// @generator action:route:type
	...createRequestTypes('@@Account', 'CHANGE_PASSWORD'),
	// @generator action:route:type:request
};

// ------------------------------------
// Actions
// ------------------------------------
/** @action request
 * * Insert a description
 * @name changePassword
 * @return {object} - The action object
 */
export const changePassword = new MakeRequest('Account', 'change_password');

// @generator action:route:request

// @generator action:route
